import diySearch from './diySearch.vue'
const diy_search = {
    install: function(Vue) {
        Vue.component('diy_search', diySearch)
    }
};
// 导出组件
export default diy_search